import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "empty-state"
}

import { IonButton, IonButtons, IonContent, IonFab, IonFabButton, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonNote, IonTitle, IonToolbar, modalController } from '@ionic/vue';
import { translate } from '@hotwax/dxp-components';
import { onMounted, ref } from 'vue';
import { closeOutline, saveOutline } from "ionicons/icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'ArchivedRuleModal',
  props: ["archivedRules"],
  setup(__props) {

const props = __props

const rulesToUnarchive = ref([]) as any;
const rules = ref([]) as any;

onMounted(() => {
  rules.value = JSON.parse(JSON.stringify(props.archivedRules))
})

function closeModal() {
  modalController.dismiss();
}

function unarchiveRule(currentRule: any) {
  rulesToUnarchive.value.push(currentRule);
  currentRule.isArchived = true;
}

function save() {
  modalController.dismiss({ dismissed: true, rulesToUnarchive: rulesToUnarchive.value });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), { onClick: closeModal }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "icon-only",
                      icon: _unref(closeOutline)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("Archived Rules")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonList), null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rules.value, (rule) => {
              return (_openBlock(), _createBlock(_unref(IonItem), {
                key: rule.ruleId
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(rule.ruleName), 1)
                    ]),
                    _: 2
                  }, 1024),
                  (rule.isArchived)
                    ? (_openBlock(), _createBlock(_unref(IonNote), {
                        key: 0,
                        slot: "end"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Unarchived")), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_unref(IonButton), {
                        key: 1,
                        slot: "end",
                        fill: "outline",
                        color: "medium",
                        onClick: ($event: any) => (unarchiveRule(rule))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Unarchive")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        (!rules.value.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(translate)("No archived rules")), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFab), {
      vertical: "bottom",
      horizontal: "end",
      slot: "fixed"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonFabButton), {
          disabled: !rulesToUnarchive.value?.length,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (save()))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonIcon), { icon: _unref(saveOutline) }, null, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    })
  ], 64))
}
}

})